<div class="h-full relative z-0">
  <div class="absolute top-0 h-10 items-center w-full z-20 flex pl-4 pr-6 overflow-visible top-bar">
    <!-- TOP LEFT -->
    <div class="w-36  shrink-0 sticky left-0 z-20 top-0 pt-20 ">
      <div class="bg-white/90 px-2 py-1 w-fit shadow-lg rounded-lg">
        <div class="flex items-center gap-2 transition-opacity duration-500" [ngClass]="{'opacity-50': !showSeed}">
          <div class="rounded-full w-6 h-2 " [style.background-color]="COLORS.PERIODS.SEEDLING"></div>
          <span class="text-xs text-grey-700" (click)="toggleType('seed')">{{'agenda.legend.seedling' |
            translate}}</span>
        </div>
        <div class="flex items-center gap-2 transition-opacity duration-500" [ngClass]="{'opacity-50': !showHarvest}">
          <div class="rounded-full w-6 h-2 " [style.background-color]="COLORS.PERIODS.HARVEST"></div>
          <span class="text-xs text-grey-700" (click)="toggleType('harvest')">{{'agenda.legend.harvest' |
            translate}}</span>
        </div>
      </div>
    </div>
    <!-- MONTHS -->
    <div class="pt-20 w-full">
      <vw-calendar-months-header [currentMonth]="currentMonth" class="w-full"></vw-calendar-months-header>
    </div>
  </div>
  @if (!isLoading) {
  <div class="h-full pt-24 flex flex-col gap-4 overflow-y-scroll overflow-x-hidden relative rounded-l-lg px-4 pb-56"
    style="--webkit-overflow-scrolling: touch;">
    <!-- FIRST LINE -->
    @for (hierarchy of hierarchies; track hierarchy) {
    <vw-calendar-hierarchy-card [hierarchy]="hierarchy" [showSeed]="showSeed" [showHarvest]="showHarvest"
      (cultivationSelected)="onCultivationSelected($event)"></vw-calendar-hierarchy-card>
    }
  </div>
  }
  @if (isLoading) {
  <div class="flex flex-col gap-4 pt-24 px-4">
    @for (i of [1,2,3,4,5,6,7,8,9,10]; track i) {
    <vw-skeleton-loader [width]="'100%'" [height]="'48px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
    }
  </div>
  }
  <div class="h-full w-full">
    <vw-calendar-month-line [position]="currentMonth"
      (positionChange)="onPositionChange($event)"></vw-calendar-month-line>
  </div>
</div>